import React, {useCallback} from 'react';

import {UserStateCriteria as UserStates} from 'src/openapi/admin/models/UserStateCriteria';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';

import {USER_STATES_CAPTIONS} from '../../constants';

import type {UserStateCriteria} from 'src/openapi/admin/models/UserStateCriteria';

type Props = {
    userStates: UserStateCriteria[],
    onSelect: (states: UserStateCriteria[]) => void,
    disabled?: boolean,
    onFocus?: () => void,
};

export const UserStateSuggest = ({userStates, onSelect, disabled, onFocus}: Props) => {
    const changeUserStates = useCallback((states: string[]) => {
        onSelect(states as UserStates[]);
    }, [onSelect]);

    return (
        <ComboBox
            disabled={disabled}
            placeholder="Select user states"
            multiselectable={true}
            value={userStates}
            onFocus={onFocus}
            onChange={changeUserStates}>
            <ComboboxItem
                caption={USER_STATES_CAPTIONS[UserStates.LICENSED]}
                value={UserStates.LICENSED}
                key={UserStates.LICENSED}
            />
            <ComboboxItem
                caption={USER_STATES_CAPTIONS[UserStates.MOBILE]}
                value={UserStates.MOBILE}
                key={UserStates.MOBILE}
            />
            <ComboboxItem
                caption={USER_STATES_CAPTIONS[UserStates.CRM_ONLY]}
                value={UserStates.CRM_ONLY}
                key={UserStates.CRM_ONLY}
            />
            <ComboboxItem
                caption={USER_STATES_CAPTIONS[UserStates.DISABLED]}
                value={UserStates.DISABLED}
                key={UserStates.DISABLED}
            />
            <ComboboxItem
                caption={USER_STATES_CAPTIONS[UserStates.NO_ACCESS]}
                value={UserStates.NO_ACCESS}
                key={UserStates.NO_ACCESS}
            />
            <ComboboxItem
                caption={USER_STATES_CAPTIONS[UserStates.CREDIT_ALERTS_ONLY]}
                value={UserStates.CREDIT_ALERTS_ONLY}
                key={UserStates.CREDIT_ALERTS_ONLY}
            />
        </ComboBox>
    );
};
